
export default class Alert {
    constructor (dto) {
        this.id = 0
        this.documentId = 0
        this.notifyByEmail = false
        this.date = ''
        this.description = ''

        if (dto) {
            this.id = dto.AlertID
            this.documentId = dto.ObjectID
            this.notifyByEmail = dto.NotifyByEmail
            this.date = dto.Date
            this.description = dto.Description
        }
    }

    toDto () {
        return {
            AlertID: this.id,
            ObjectID: this.documentId,
            Date: this.date,
            NotifyByEmail: this.notifyByEmail,
            Description: this.description,
        }
    }
}
